// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3TJDF","row":"row__1xrMO","rowWrapper":"rowWrapper__2BkVZ","rowWrapperItem":"rowWrapperItem__1DG1M","rowText":"rowText__3TWfC","country_percentage":"country_percentage__2fyVH","countryWrapper":"countryWrapper__WJygE","allDonorWrapper":"allDonorWrapper__3An4p","tooltipDonors":"tooltipDonors__2hnvC","tooltipDisplay":"tooltipDisplay__3qV8B","targetTitle":"targetTitle__XuMsc"};


//////////////////
// WEBPACK FOOTER
// ./components/target-budget-expense-item/style.scss
// module id = 7QFR
// module chunks = 0